<template>
  <div
    class="card add-product-card-skeleton"
    data-testid="add-product-card-skeleton"
  >
    <div
      class="add-product-card-skeleton__header"
      data-testid="add-product-card-skeleton-header"
    >
      <div class="add-product-card-skeleton__content">
        <div class="add-product-card-skeleton__box" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.add-product-card-skeleton {
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  position: relative;

  &__header {
    position: relative;
    background: $color-gray-95;
  }

  &__content {
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 1.125rem 0.75rem;
  }

  &__box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 7.8125rem;   // 125px
    height: 7.8125rem;  // 125px

    @include breakpoint('sm') {
      width: 9.375rem;  // 150px
      height: 9.375rem; // 150px
    }
  }
}

/* Sticky menu variant */
.sticky-menu.active .add-product-card-skeleton {

  &__header,
  &__content {
    display: block;
  }

  &__box {
    width: 3.75rem; // 60px
    height: 3.75rem; // 60px
  }
}
</style>
